/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IMediaGalleryThumbnailItemViewProps, IMediaGalleryThumbnailsViewProps, IMediaGalleryViewProps } from '@msdyn365-commerce-modules/media-gallery/src/modules/media-gallery/../..';

const MediaGalleryView: React.FC<IMediaGalleryViewProps> = props => {
	const { CarouselProps, Thumbnails, MediaGallery, Modal } = props;
	let items = Thumbnails ? Thumbnails.items : null;
	if(items && items.length <= 2){
		MediaGallery.className += ' no-thumbs';
	}
	return (
		<Module {...MediaGallery}>
			<Node {...CarouselProps}/>
			{Modal}
			{_renderThumbnails(Thumbnails)}
		</Module>
	);
};

//Added length >= 2 to prevent only single thumbnails from rendering
const _renderThumbnails = (thumbnails: IMediaGalleryThumbnailsViewProps): JSX.Element => {
	const { ThumbnailsContainerProps, SingleSlideCarouselComponentProps, items } = thumbnails;
	if(items && items.length >= 2){
		return (
			<div className="ms-media-gallery__thumbnails-container no-thumbs">
				<Node {...SingleSlideCarouselComponentProps}>{items && items.map(_renderThumbnailItem)}</Node>
			</div>
		);
	} else {
		return <Node {...ThumbnailsContainerProps}></Node>
	}
};

const _renderThumbnailItem = (thumbnail: IMediaGalleryThumbnailItemViewProps): JSX.Element => {
	const { ThumbnailItemContainerProps, Picture } = thumbnail;

	return <Node {...ThumbnailItemContainerProps}>{Picture}</Node>;
};

export default MediaGalleryView;
